import React, { useState } from "react";
import CommonModal from "../CommonModal/CommonModal";
import { IoMdDownload } from "react-icons/io";
import CommonButton from "../CommonButton/CommonButton";
import "./CommonPreview.scss";

type Props = {
  fileUrl: string;
  showDownloadButton?: boolean;
};

const FileViewer: React.FC<Props> = ({
  fileUrl,
  showDownloadButton = true,
}) => {
  const [isModalOpen, setModalOpen] = useState(false);

  const fileExtension = fileUrl.split(".").pop()?.toLowerCase();
  const lowerUrl = fileUrl.toLowerCase();

  const renderFileContent = () => {
    if (
      lowerUrl.includes(".jpg") ||
      lowerUrl.includes(".jpeg") ||
      lowerUrl.includes(".png") ||
      lowerUrl.includes(".gif") ||
      lowerUrl.includes(".webp")
    ) {
      return (
        <img src={fileUrl} alt="file preview" style={{ maxWidth: "100%" }} />
      );
    }

    if (lowerUrl.includes(".mp4") || lowerUrl.includes(".webm")) {
      const fileType = lowerUrl.includes(".mp4") ? "mp4" : "webm";
      return (
        <video controls width="100%">
          <source src={fileUrl} type={`video/${fileType}`} />
          Your browser does not support the video tag.
        </video>
      );
    }

    if (lowerUrl.includes(".pdf")) {
      return (
        <iframe
          src={fileUrl}
          style={{ width: "100%", height: "600px", border: "none" }}
          title="PDF Viewer"
        />
      );
    }

    if (lowerUrl.includes(".doc") || lowerUrl.includes(".docx")) {
      return (
        <iframe
          src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
            fileUrl
          )}`}
          style={{ width: "100%", height: "600px", border: "none" }}
          title="Word Document Viewer"
        />
      );
    }

    return <p>Preview not supported for this file type.</p>;
  };

  const handlePreviewClick = () => {
    setModalOpen(true);
  };

  // DONT REMOVE THIS - FOR HANDLING DOWNLOAD
  // const handleDownload = async () => {
  //   try {
  //     const response = await fetch(fileUrl, {
  //       mode: "cors",
  //     });

  //     if (!response.ok) {
  //       throw new Error("Failed to fetch file.");
  //     }

  //     const blob = await response.blob();

  //     const blobUrl = window.URL.createObjectURL(blob);
  //     const a = document.createElement("a");
  //     a.href = blobUrl;
  //     a.download = fileUrl.split("/").pop() || "download";
  //     document.body.appendChild(a);
  //     a.click();
  //     a.remove();

  //     window.URL.revokeObjectURL(blobUrl);
  //   } catch (error) {
  //     console.error("Download failed:", error);
  //     alert("Unable to download the file.");
  //   }
  // };

  const handleDownload = () => {
    const fileName = fileUrl.split("/").pop() || "file";
    const link = document.createElement("a");

    link.href = fileUrl;
    link.setAttribute("download", fileName);
    link.setAttribute("rel", "noopener noreferrer");
    link.setAttribute("target", "_blank");

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <div className="common-attachment-preview" onClick={handlePreviewClick}>
        {renderFileContent()}
      </div>

      {/* {showDownloadButton && (
        <CommonButton
          btnText="&nbsp;Download"
          onClick={handleDownload}
          className="w-auto ps-4 pe-4 default-text"
          height="40px"
          backgroundColor="transparent"
          border="none"
          icon={IoMdDownload}
          borderRadius="8px"
        />
      )} */}

      <CommonModal
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
        showCloseIcon={true}
        title=""
        size="xl"
        bodyContent={
          <div className="m-3">
            <div className="mb-3">{renderFileContent()}</div>
          </div>
        }
        footerContent={
          showDownloadButton ? (
            <div className="me-3 float-right">
              <CommonButton
                btnText="&nbsp;Download"
                onClick={handleDownload}
                className="w-auto ps-4 pe-4 mb-2 default-text"
                height="40px"
                backgroundColor="transparent"
                border="2px solid var(--primary-text-color)"
                icon={IoMdDownload}
                borderRadius="8px"
              />
            </div>
          ) : null
        }
      />
    </>
  );
};

export default FileViewer;
